window.addEventListener("DOMContentLoaded", function () {
  InitReferralTracking();

  function InitReferralTracking() {

    // ★ ここで切り替え
    const ATTRIBUTION_MODE = "last"; // "first" or "last"

    const params = new URLSearchParams(window.location.search);
    const refFromUrl = params.get('ref');

    function getCookie(name) {
      const match = document.cookie.match(
        new RegExp('(?:^|; )' + name + '=([^;]*)')
      );
      return match ? decodeURIComponent(match[1]) : null;
    }

    // 6ヶ月
    const expires = new Date(
      Date.now() + 180 * 24 * 60 * 60 * 1000
    ).toUTCString();

    const beforeRef = getCookie('ref');

    // =========================
    // ① アトリビューション制御
    // =========================
    if (refFromUrl) {

      if (ATTRIBUTION_MODE === "first") {
        // ファーストタッチ：既存がなければ保存
        if (!beforeRef) {
          document.cookie =
            `ref=${encodeURIComponent(refFromUrl)}; expires=${expires}; path=/; SameSite=Lax`;
        }
      }

      if (ATTRIBUTION_MODE === "last") {
        // ラストタッチ：毎回上書き
        document.cookie =
          `ref=${encodeURIComponent(refFromUrl)}; expires=${expires}; path=/; SameSite=Lax`;
      }
    }

    const afterRef = getCookie('ref');

    if (refFromUrl) {
      alert(
        "モード: " + ATTRIBUTION_MODE + "\n" +
        "URLのref: " + refFromUrl + "\n" +
        "変更前のCookie ref: " + beforeRef + "\n" +
        "変更後のCookie ref: " + afterRef
      );
    }

    // Shopifyへ送信
    if (afterRef) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { ref: afterRef }
        })
      }).catch(err => console.error("cart update failed", err));
    }
  }
});

window.addEventListener("DOMContentLoaded", function () {
  ChangeTextRefundPolicy();

  function ChangeTextRefundPolicy() {
    // ページ内のすべてのテキストノードを取得
    const treeWalker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    // 各テキストノードに対して置換処理を行う
    while (treeWalker.nextNode()) {
      const node = treeWalker.currentNode;
      if (node.nodeValue.includes("返金ポリシー")) {
        node.nodeValue = node.nodeValue.replace(
          /返金ポリシー/g,
          "返品・交換ポリシー"
        );
      }
    }
  }
});

window.addEventListener("DOMContentLoaded", function () {
  ScrollSectionInSizeGuide();

  function ScrollSectionInSizeGuide() {
    const path = decodeURIComponent(window.location.pathname);

    if (path.includes("/pages/サイズガイド")) {
      setTimeout(function () {
        window.scrollBy({ top: -150, behavior: "smooth" });
      }, 300);
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const badges = document.querySelectorAll(".badge--bottom-left");

  badges.forEach(function(badge) {
    if (badge.textContent.trim() === "売り切れ") {
      badge.textContent = "Sold out";
    }
  });
});

// window.addEventListener("DOMContentLoaded", function() {
//   UndisplayNewItemFromProductList();

//   function UndisplayNewItemFromProductList() {
//     if (window.location.href.includes('https://se-tu.jp/')) {
//       const links = document.querySelectorAll('.full-unstyled-link');

//       links.forEach(link => {
//         if (link.textContent.trim() === 'ワイドデニムパンツ') {
//           const productItem = link.closest('li.grid__item');
//           if (productItem) {
//             productItem.style.display = 'none';
//           }
//         }
//       });
//     }
//   }
// });
